import { t } from 'i18next';

export const nullDataChartLabel = () => t('dashboard.not_specified_label');
